import React from 'react';

import { Typography } from '@lyearn/ui';
import fileSize from '@/utils/fileSize';

import { useMediaContext } from '../context';

function MediaSize() {
  const { media } = useMediaContext();

  return (
    <Typography className="uppercase" color="text-text-secondary" variant="body-short-03">
      {fileSize(media.size ?? 0, { base: 2, standard: 'jedec' }) as string}
    </Typography>
  );
}

export default React.memo(MediaSize);
